import FlatatsicConfig from '../../scripts/config'
import ActionsheetService from '../../scripts/modules/yptActionsheet'
import CordovaService from '../../scripts/modules/yptCordova'
import LanguageService from '../../scripts/modules/yptLanguage'
import SocialSharingService from '../../scripts/modules/yptSocialsharing'
import UserService from '../user/svc_user'

export default angular.module('flatastic.settings.controller', [
  CordovaService,
  SocialSharingService,
  ActionsheetService,
  LanguageService,
  FlatatsicConfig,
  UserService,
])

.controller('SettingsCtrl',
    ['$scope', 'yptNotify', 'yptSocialsharing', 'yptActionsheet', 'yptCordova',
    'Config', '$filter', 'User', 'yptLanguage', '$window',
    '$rootScope',
    function ($scope, yptNotify, yptSocialsharing, yptActionsheet, yptCordova,
    Config, $filter, User, yptLanguage, $window,
    $rootScope) {

  $scope.versionNumber = Config.versionNumber;

  $scope.showHelp = function() {
    yptNotify.alert({
      title: $filter('translate')('SET__HELP-TITLE'),
      message: $filter('translate')('SET__HELP-MSG'),
      trackEvent: {
        name: 'showHelp',
        parameters: {
          context: 'settings',
        },
      },
    });
    $rootScope.$broadcast('track-event', {
      category: 'Help',
      action: 'Clicked',
      label: '/settings',
    });
  };

  $scope.isMobileApp = ionic.Platform.isIOS() || ionic.Platform.isAndroid();

  $scope.User = User;
  $scope.languages = [{
    label: 'English',
    value: 1,
  }, {
    label: 'Deutsch',
    value: 2,
  }, {
    label: 'Schwiizerdütsch',
    value: 3,
  }, {
    label: 'Österreichisch',
    value: 4,
  }];
  $scope.setLanguage = function() {
    User.update({ language: User.properties.language })
      .then(() => $window.location.reload())
    var languages = ['en', 'de', 'de', 'de'];
    var chosenLanguage = languages[User.properties.language - 1];
    $window.localStorage['Flatastic.userLanguage'] = chosenLanguage;
    yptLanguage.set(chosenLanguage);
  };

  $scope.share = function() {
    yptSocialsharing.share({
      subject: $filter('translate')('SET__SHARE-TITLE'),
      message: $filter('translate')('SET__SHARE-MSG'),
      url: 'https://flatastic-app.com/app',
      trackEvent: {
        event: 'Share',
        context: 'settings',
        content: $filter('translate')('SET__SHARE-TITLE'),
      },
    });
  };

  $scope.showLawStuff = function() {
    var options = {
      title: $filter('translate')('SET__LAW_STUFF-TITLE'),
      buttonLabels: [
        $filter('translate')('SET__LAW_STUFF-BTN_AGB'),
        $filter('translate')('SET__LAW_STUFF-BTN_PRIVACY'),
      ],
      'androidEnableCancelButton': false,
      'addCancelButtonWithLabel': $filter('translate')('BTN_CANCEL'),
    };
    var actions = [
      function() {
        yptCordova.openLink('https://flatastic-app.com/impressum?utm_source=flatastic&utm_medium=app&utm_campaign=settings');
      },
      function() {
        yptCordova.openLink('https://flatastic-app.com/privacy?utm_source=flatastic&utm_medium=app&utm_campaign=settings');
      },
    ];
    yptActionsheet.show(options, actions);
  };

}])

.name;
